module.exports = __webpack_public_path__ + "static/media/sellers-stock.0228c553.png";